import React, { useState } from 'react';
import { X, Search } from 'lucide-react';

interface AddContactFormProps {
  onSubmit: (email: string, notes?: string) => void;
  onClose: () => void;
}

export function AddContactForm({ onSubmit, onClose }: AddContactFormProps) {
  const [email, setEmail] = useState('');
  const [notes, setNotes] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!email.includes('@')) {
      setError('Please enter a valid email address');
      return;
    }

    onSubmit(email, notes);
  };

  return (
    <div className="modal-container">
      <div className="modal-content">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-xl font-semibold">Add Trusted Contact</h3>
          <button
            onClick={onClose}
            className="p-2 hover:bg-black/20 rounded-full"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm text-gray-400 mb-1">Email Address</label>
            <div className="relative">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter email address"
                className="w-full pl-10 pr-4 py-2 bg-black/20 rounded-xl text-white"
                required
              />
            </div>
          </div>

          <div>
            <label className="block text-sm text-gray-400 mb-1">Notes (Optional)</label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Add a note about this contact"
              className="w-full px-4 py-2 bg-black/20 rounded-xl text-white h-24 resize-none"
            />
          </div>

          {error && (
            <div className="p-3 bg-red-500/10 text-red-500 rounded-xl text-sm">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="w-full bg-[#bbdde5] text-black rounded-xl py-3 font-medium hover:opacity-90 transition-opacity"
          >
            Add Contact
          </button>
        </form>
      </div>
    </div>
  );
}